/**
 * Created by nikhil on 7/28/15.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('PlaybackStats', function getMetrics($resource) {
        return $resource('api/stream/metrics');
    })
    .factory('AssetStats', function getAssetStats($resource) {
        return $resource('api/stream/collection/assets');
    })
    .factory('DropOffStats', function getDropOffMetrics($resource) {
        return $resource('api/stream/drop');
    })
    .factory('UserStatsByFrequency', function getUniqueUsersByFrequency($resource) {
        return $resource('api/stream/users');
    })
    .factory('DeviceOSMetrics', function getDeviceAndOSMetrics($resource) {
        return $resource('api/stream/device/metrics');
    }).factory('mediaDropOff', function () {

        var mediaPlayBack = {};

        mediaPlayBack.playMedia =  function(hasPlayingStarted, isPlayingDone, collectionId, assetId){
            mediaPlayBack.collectionId = collectionId;
            mediaPlayBack.assetId = assetId;
            mediaPlayBack.videoPlayed = hasPlayingStarted;
            mediaPlayBack.playingDone = isPlayingDone;
        }
        return mediaPlayBack;
    }).factory('mediaPauseAndDropOff', function () {

        var mediaPause = {};

        mediaPause.pauseDropOff =  function(isPaused, collectionId, assetId, secondsPlayed, mediaDuration){
            mediaPause.isPlayed = true;
            mediaPause.isPaused = isPaused;
            mediaPause.collectionId = collectionId;
            mediaPause.assetId = assetId;
            mediaPause.secondsPlayed = secondsPlayed;
            mediaPause.mediaDuration = mediaDuration;
        }
        return mediaPause;
    });

